import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col } from 'react-bootstrap'
import { PersonCircle } from 'react-bootstrap-icons'
import './about.css'
import banner from '../../Assets/img/banner2.avif'
import Footer from '../Footer'

import priyansh from '../../Assets/img/Board/Priyash Nigam.webp'
import pkImg from '../../Assets/img/Board/PK Joseph board.jpg'
import narenImg from '../../Assets/img/Board/Naren Verma board.jpg'
import kartikImg from '../../Assets/img/Board/Kartik board.jpg'
import mohiniImg from '../../Assets/img/Board/Mohini board.jpg'
import indrajitImg from '../../Assets/img/Board/Indrajit Ghosh board.png'
import bhavyaImg from '../../Assets/img/Board/Bhavya board.png'
import amanImg from '../../Assets/img/Board/Amandeep board.JPG'
import sudarshanImg from '../../Assets/img/Board/Sudarshan.png'
import shivajiImg from '../../Assets/img/Board/Shivaji Maitra.jpg'
import shrutiImg from '../../Assets/img/Board/Dr. Shruti Jain.jpeg'
import kirtiImg from '../../Assets/img/Board/Kirti Mehta.jpeg'
import shweta from '../../Assets/img/Board/shwetakhanna.jpg'
import JosephImg from "../../Assets/img/Testimonials/Joseph John.jpeg"
import vivekImg from "../../Assets/img/Testimonials/Vivek Verma.jpg"
import PoulomiImg from "../../Assets/img/Board/Poulomi Goswami.png"
import PublicHeader from '../Header/PublicHeader'

// Board Members Data
const boardMembers = [
  // Remove Naren from regular board members array
  

  { name: 'PK Joseph', 
    position: 'Director', 
    image: pkImg, 
    type: 'board', 
    bio: "Mr PK Joseph, after a decade-long work in education and career services, founded CareerSpotters Global Pvt Ltd, an innovative career planning and career services company, headquartered at New Delhi. Mr Joseph holds two post-graduate degrees i.e. MA (SW), specialised in Youth Welfare and an MBA. He has also to his credit several certifications in career counselling including Global Career Counseling Certification, University of California, Certified Career Analyst; Certified Career Counsellor for International Studies from Edumilestones; and Green Belt Certification in Career Counseling; and Certificate of Premium Overseas Admission from Univariety.Mr Joseph served previously as Director Programmes (Education), DLF Ltd (CSR), DLF Foundation, Director-Cum School Manager with Ridge Valley School, Gurugram and SB Mills Sr Sec School, Delhi. Regional Director-Asia, Youth Employment Summit Campaign, EDC Inc. USA, and Deputy Director, CII.Mr Joseph joined the Board of Directors as he believes in empowering Professional career counsellors with required career counselling expertise, knowledge creation and sharing by fostering a national level network of career professionals." },
  
  {
    name: 'Indrajit Ghosh',
    position: 'Director',
    image: indrajitImg,
    type: 'board',
    bio:"Indrajit Ghosh, a seasoned entrepreneur and thought leader, brings over two decades of expertise in Animation, Visual Effects, Gaming, Comics, and Extended Reality (AVGC XR). As a Board Member of APCCI, he plays a key role in integrating industry insights into career counseling, ensuring career counsellors are equipped with the right skills and opportunities in the evolving Media & Entertainment sector.With a strong background in establishing industry-integrated training institutes and mentoring creative talent, Indrajit actively contributes to APCCI’s mission of bridging education and industry. His advocacy efforts with policymakers and educators aim to position AVGC XR as a recognized academic and career stream in India.At APCCI, Indrajit helps shape strategies that enhance the professional growth of career counselors, nurturing APCCI as a dynamic platform where innovation, industry alignment, and career development go hand in hand."
  },
]

const formerDirectors = [
  {
    name: 'Bhavya Singh J',
    position: '',
    image: bhavyaImg,
    type: 'board',
    // bio:"Bhavya Singh J's foundation in scientific research (Geology, Physical Geography, and GIS), artistic expression, and athletic discipline fosters a holistic approach to guidance. This diverse skillset, particularly her ability to connect with individuals on a deeply human level, underscores her commitment to empowering others.Certified as a Green Belt by Univariety and a Global Career Counsellor by UCLA, she prioritizes the development of the whole person, a value demonstrated by her early and active involvement in the 'Career Launch Gurus' community that emerged as APCCI.Her early immersion in the counseling community drew her to this democratic community, resonating with its collaborative and empowering ethos. She believes in the transformative power of well-supported career counsellors and aims to contribute to a platform that elevates the profession, ensuring access to informed and impactful career guidance for all."
  },
  {
    name: 'Amandeep Singh Bhachu',
    position: '',
    image: amanImg,
    type: 'board',
    // bio: 'Amandeep Singh Bhachu is an Educational Consultant and Business Leader with 15 years of experience in overseas education, executive learning, and business strategy. As an APCCI Board Member, he contributes to strategy building and policy development, helping shape the organization’s direction in overseas education.With a background in sales, market expansion, and student recruitment, Amandeep has worked with professionals pursuing IIM and IIT executive programs and has facilitated admissions to top universities across the USA, UK, Canada, Australia, New Zealand, and Europe through Global Path Careers and Apply Panacea.At APCCI, his expertise in process standardization and strategic planning strengthens the platform’s role in supporting career counselors and advancing the overseas education ecosystem.' ,
  },
  {
    name: 'Kartik Baldwa',
    position: '',
    image: kartikImg,
    type: 'board',
    // bio:"Kartik Baldwa is an internationally certified career counselor with over 15 years of experience in guiding students toward the right career paths. An engineer and MBA in finance, he started his career at Infosys and later served as Operations Head in the manufacturing sector. However, his passion for mentoring led him to transition into career counseling and competitive exam training, helping students prepare for CAT, JEE, GRE, GMAT, IPMAT, SAT, and more.As the Director of Ekoching, an Ahmedabad-based EdTech company, he has played a key role in helping students secure admissions in IIMs, NLUs, IITs, and other prestigious institutions. His company also collaborates with top universities and schools across Gujarat, including Nirma University, PDEU, Karnavati University, and Marwadi University.At APCCI, Kartik contributes his expertise in career guidance and exam mentoring, ensuring members receive structured support in their professional journeys.Beyond counseling, Kartik is an avid traveler and poet, drawing inspiration from his experiences to help students see learning as a lifelong journey."
  },
  {
    name: 'Mohini Piyush Majithia',
    position: '',
    image: mohiniImg,
    type: 'board',
    // bio:"Mohini Majithia is a career counselling icon, a 15-year experience turned into a change creator and consultant to change management. She has expertise beyond the conventional methods - she is also educated in the psychology of the youth's brain, outside the boundaries, overcomes obstacles and scales the summit of successes. A mentor respected by toppers in top schools, she has influenced countless lives through high-impact workshops, individual counselling, and strategic global admissions profile development. As a member of the APCCI board, Mohini goes all out in her quest to revolutionise career counselling, preparing professionals with current insights, latest tools, and industry exposure. She feels that real power resides not in recommendation but in taking action, ensuring that every student she counsels, walks into his or her greatest potential. In her own words:'Career counselling isn’t just about paths—it’s about possibilities, and I make sure no dream is left unexplored.'"
  },
  
]

// Create separate object for Naren with description
const chairmanMember = {
  name: 'Naren Verma',
  position: 'Founder & Executive Chairman',
  image: narenImg,
  type: 'board',

  description:
    ' Naren Verma, a<strong> Soldier</strong> turned<strong> Entrepreneur, Co-founder & Managing Director </strong>of Career Spotters Global Pvt Ltd is a <strong>Seasoned Leader </strong>with over 20 years of experience in the Indian Air Force. He is the <strong>driving force</strong> behind the <strong>Association of Professional Career Counsellors of India</strong> (APCCI). Supported by a <strong>Board of Directors, National Advisory Council</strong> and a <strong>committed team of over 50 volunteer career counsellors </strong>, Naren brings a clear vision and passion to make APCCI evolve everyday.\n\nUnder Naren’s leadership, <strong>APCCI has evolved</strong> from a small whatsApp community <strong>"Career Launch Gurus"</strong> into <strong>APCCI</strong>, a recognized <strong>National Platform</strong> to support career counselling professionals across India. His approach, shaped by his military background, emphasizes planning, discipline, and adaptability, ensuring actionable and results-driven guidance.\n\nNaren’s goal is ambitious yet focused: <strong>equipping Professional career counsellors</strong> with the requisite <strong>Knowledge, Skills, Tools and Industry Exposure</strong> to impact the students in masses.\n\nWith Naren leading the way, APCCI remains a <strong>democratic community driven by counsellors, for counsellors</strong>. It’s a platform where career counsellors find <strong>Direction, Support, and the Confidence</strong> to grow in their professional practice.\n\n<strong>Join us</strong> in this inspiring journey, and <strong>Be part</strong> of a community that’s shaping the future of career counselling in India.'
}

// Honorary Board Members Data
// const honoraryMembers = [
//   {
//     name: 'Sudarshan Sharma',
//     position: 'Deputy Manager, L&D KEI Industries Ltd',
//     image: sudarshanImg,
//     bio: 'Sudarshan Sharma, a Learning & Development specialist with 10+ years of experience, excels in designing training solutions that drive individual and organizational growth. As Deputy Manager, L&D at KEI Industries Ltd., he has led workforce development for 2,000+ employees using LMS technology. With expertise in leadership development and curriculum design, he has delivered 15,000+ hours of life skills coaching. As an External Domain Expert Advisor at APCCI, he enhances training methodologies, ensuring impactful, ethical, and structured learning experiences for members.',
//     type: 'honorary'
//   },
//   {
//     name: 'Dr. Shruti Jain',
//     position: 'Senior Career Counsellor Mentor',
//     image: shrutiImg,
//     bio: 'Dr. Shruti Jain, a certified career counselor with 15+ years of experience, specializes in career guidance, counseling methodologies, and skill development. With a Bachelor of Dental Surgery from Mysore University and a PG Diploma in Guidance & Counselling from Jamia Millia Islamia, she has guided countless students in making informed career choices. As an External Domain Expert Advisor at APCCI, she enhances counseling frameworks, develops strategies, and trains counselors with essential skills to provide impactful career guidance and support.',
//     type: 'honorary'
//   },
//   {
//     name: 'Harpal Singh',
//     position: 'Founder & CEO Mentorpal.ai',
//     image: harpal,
//     bio: 'Harpal Singh, CEO and Founder of MentorPal, is a technology leader with 15+ years of experience in software development, cybersecurity, and tech hiring. He specializes in optimizing IT processes, streamlining recruitment, and building high-performing tech teams. With expertise in emerging technologies and data-driven hiring, he aligns tech professionals with industry needs. As an External Domain Expert Advisor at APCCI, he enhances career counseling for tech careers by contributing insights on IT infrastructure, cybersecurity best practices, and technology-driven process improvements.',
//     type: 'honorary'
//   },
//   {
//     name: 'Shivaji Maitra',
//     position: 'Geophysics Lead Asia Pacific SLB',
//     image: shivajiImg,
//     bio: 'Shivaji Maitra, with 20 years of global experience, specializes in strategic planning, team development, and corporate presentations. With a background in geophysics, earth sciences, and data science, he has led 100+ seismic imaging projects and authored 35+ international papers. His expertise spans personal branding, networking, and effective communication. As an External Domain Expert Advisor at APCCI, he enhances career guidance for emerging fields, helping counselors equip individuals with skills for strategic career planning, impactful presentations, and long-term professional growth.',
//     type: 'honorary'
//   },
//   {
//     name: 'Priyash Nigam',
//     position: 'CEO Execube digital',
//     image: priyansh,
//     bio: 'Priyash Nigam, CEO of Execube Digital, is a digital marketing strategist with 9+ years of experience in performance marketing, automation, and brand growth. With a Master’s in International Marketing Management from Leeds University, he specializes in Meta & Google Ads, conversion funnels, and corporate training. A Meta & Google-certified expert, he collaborates with Meta and WhatsApp on business insights. As an External Domain Expert Advisor at APCCI, he helps counselors enhance their digital presence, outreach, and brand visibility for growth.',
//     type: 'honorary'
//   },
//   {
//     name: 'Shweta Khanna Bhandral',
//     position: 'Media Educator and Counsellor',
//     image: shweta,
//     bio: "Shweta Khanna Bhandral is an NCDA-certified career counsellor, media educator, and skill development coach with over 25 years of cross-sector experience, she specializes in visual storytelling and content creation, as she trains and mentors youth and professionals.As a Google News Initiative (GNI) India trainer for media literacy she connects with all age groups, across sections of society. She curates impactful learning experiences that bridge skills, education, and career, as Founder Director of FutSki Labs, At APCCI's National Advisory Council, she is an Expert Advisor – Media & Publicity as she supports strategic outreach and communication to strengthen the visibility and voice of India's counselling ecosystem.",
//     type: 'honorary'
//   }
// ]

// APCCI Central Secretariat Members Data
const secretariatMembers = [
  // {
  //   name: 'Bhavya Singh J',
  //   image: bhavyaImg,
  //   position: 'Head of the Central Secretariat',
  //   bio: 'Bhavya Singh J, Head of the Central Secretariat at APCCI, fosters a collaborative and efficient environment. With a background in Geology, GIS, and Remote Sensing, she brings analytical rigor to organizational challenges. Deeply committed to APCCI’s democratic ethos, she ensures transparency, streamlined processes, and clear communication. Her early involvement with APCCI drives her passion for empowering career counselors. Bhavya’s work lays a strong foundation for making career counseling more accessible, impactful, and supportive across India, strengthening the community’s growth.',
  //   type: 'secretariat'
  // },
  {
    name: 'Joseph John',
    image: JosephImg,
    position: 'General Secretary',
    bio: 'Joseph John, a dedicated member of APCCI’s Central Secretariat, brings a wealth of experience in career counseling and organizational support. With a strong background in educational guidance, he plays a pivotal role in ensuring the smooth functioning of APCCI’s initiatives. Joseph is committed to fostering collaboration among career counselors, streamlining processes, and enhancing communication within the organization. His efforts contribute significantly to creating a supportive and resourceful environment for career counselors across India, aligning with APCCI’s mission to empower professionals in the field.',
    type: 'secretariat'
  },

  {
    name: 'Poulomi Goswami',
    image: PoulomiImg,
    position: 'Joint Executive Secretary (Membership & Training)',
    bio: 'Poulomi Goswami is a Learning & Development and Human Resources professional with 19 years of cross-functional experience, including 9 years in HR, spanning Learning & Development, Talent Management, Employee Experience, Career Development, and the AVGC-XR ecosystem. With extensive experience across the Animation, VFX, Gaming, Media and Entertainment sectors, Poulomi is passionate about bridging the gap between education, skills, industry and career opportunities. Her areas of expertise include career development, employability, psychometric assessment, talent development, digital learning, and AI-enabled learning and career practices. Through APCCI, she aims to contribute to strengthening career counselling, industry-aligned career guidance, member engagement, and professional development for counsellors, educators, students, and emerging professionals.',
    type: 'secretariat'
  },

  {
    name: 'Vivek Verma',
    image: vivekImg,
    position: 'Technology Coordinator',
    bio: 'Vivek Verma, a B.Tech undergraduate at Netaji Subhas University of Technology (NSUT), specialising in Computer Science and Artificial Intelligence, with a strong interest in technology, web development, and digital innovation. As Digital & Technology Coordinator at APCCI, he contributes to the organisation’s digital ecosystem, including website development, digital platforms, and technology-driven initiatives. He has also contributed to the organisation and execution of AICCC, APCCI’s annual flagship event. His passion lies in leveraging technology to create meaningful digital experiences and supporting initiatives that contribute to the growth of the career counselling ecosystem.',
    type: 'secretariat'
  },
  

  // Add more members as needed
]

// Board Member Card Component
const BoardMemberCard = ({ member, isActive, onHover, onLeave }) => {
  const [isHovered, setIsHovered] = useState(false)
  const isChairman = member.position === 'Executive Chairman'

  return (
    <div
      className={`card border-0 bg-white rounded-lg overflow-hidden ${
        isActive ? 'active' : ''
      }`}
      onMouseEnter={() => {
        setIsHovered(true)
        onHover()
      }}
      onMouseLeave={() => {
        setIsHovered(false)
        onLeave()
      }}
      style={{
        transition: 'all 0.4s ease',
        transform: isHovered ? 'translateY(-8px)' : 'translateY(0)',
        boxShadow: isHovered
          ? '0 22px 40px rgba(0,0,0,0.15)'
          : '0 5px 15px rgba(0,0,0,0.08)',
        
        margin: '0 auto'
      }}
    >
      <div
        className='position-relative card-image'
        style={{
          height: isChairman ? '400px' : '300px',
          overflow: 'hidden'
        }}
      >
        {member.image ? (
          <img
            src={member.image}
            alt={member.name}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              objectPosition: 'center',
              padding: '10px',
              filter: isHovered ? 'brightness(90%)' : 'brightness(100%)',
              transition: 'all 0.4s ease'
            }}
          />
        ) : (
          <div className='d-flex align-items-center justify-content-center bg-light h-100'>
            <PersonCircle size={100} className='text-secondary opacity-25' />
          </div>
        )}
      </div>
      
<div className='card-body p-4 bg-white text-center'>
  <h4 className='mb-2 fw-bold card-title'>{member.name}</h4>
  <span className={`mb-3 d-block card-position ${isActive ? 'active' : ''}`}>
    {member.position}
  </span>
  {member.bio && (
    <p
      className="text-muted card-bio leading-relaxed text-justify mx-auto" 
      style={{
        opacity: isHovered ? 1 : 0,
        maxHeight: isHovered ? '100%' : '0',
        overflow: 'hidden',
        transition: 'all 0.4s ease',
        paddingLeft: '20px',
        textWrap: 'pretty' ,
        
      }}
    >
      {member.bio}
    </p>
  )}
</div>

    </div>
  )
}

BoardMemberCard.propTypes = {
  member: PropTypes.object.isRequired,
  isActive: PropTypes.bool.isRequired,
  onHover: PropTypes.func.isRequired,
  onLeave: PropTypes.func.isRequired
}

// Add ChairmanSection component
const ChairmanSection = ({ chairman }) => (
  <>
    <div className='text-center mb-5 mt-5'>
      <h2 className='display-4 fw-bold mb-4 board-title'>Founder & Executive Chairman</h2>
      <div className='board-divider' />
    </div>
    <Row className='justify-content-center mb-5 pt-2'>
      <Col xs={12} sm={6} md={4} lg={3} className='mb-4'>
        <BoardMemberCard
          member={chairman}
          isActive={false}
          onHover={() => {}}
          onLeave={() => {}}
        />
      </Col>
      <Col xs={12} lg={8}>
        <div
          className='chairman-description bg-white p-4 rounded-lg'
          dangerouslySetInnerHTML={{ __html: chairman.description }}
          style={{ 
            whiteSpace: 'pre-line',
            textAlign: 'justify',
            lineHeight: '1.8',
            fontSize: '1.03 rem',
            backgroundColor: '#f8f9fa',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
          }}
        />
      </Col>
    </Row>
  </>
)

ChairmanSection.propTypes = {
  chairman: PropTypes.object.isRequired
}

// Secretariat Section Component
const SecretariatSection = ({ title, members }) => {
  const [activeCard, setActiveCard] = useState(null)

  return (
    <Container className='board-members-grid'>
      <div className='text-center mb-5 mt-5'>
        <h2 className='display-4 fw-bold mb-4 board-title'>{title}</h2>
        <div className='board-divider' />
      </div>
      <Row className='justify-content-center g-4'>
        {members.map((member, idx) => (
          <Col key={idx} xs={12} sm={6} md={4} className='mb-4'>
            <BoardMemberCard
              member={member}
              isActive={activeCard === idx}
              onHover={() => setActiveCard(idx)}
              onLeave={() => setActiveCard(null)}
            />
          </Col>
        ))}
      </Row>
    </Container>
  )
}

SecretariatSection.propTypes = {
  title: PropTypes.string.isRequired,
  members: PropTypes.array.isRequired
}

// Modified BoardMembersGrid Component
const BoardMembersGrid = ({ title, members }) => {
  const [activeCard, setActiveCard] = useState(null)

  return (
    <Container className='board-members-grid'>
      {title === 'Board of Directors' && (
        <ChairmanSection chairman={chairmanMember} />
      )}
      <div className='text-center mb-5 mt-5'>
        <h2 className='display-4 fw-bold mb-4 board-title'>{title}</h2>
        <div className='board-divider' />
      </div>
      <Row className='justify-content-center g-4'>
        {members.map((member, idx) => (
          <Col key={idx} xs={12} sm={6} md={4} className='mb-4'>
            <BoardMemberCard
              member={member}
              isActive={activeCard === idx}
              onHover={() => setActiveCard(idx)}
              onLeave={() => setActiveCard(null)}
            />
          </Col>
        ))}
      </Row>
    </Container>
  )
}

BoardMembersGrid.propTypes = {
  title: PropTypes.string.isRequired,
  members: PropTypes.array.isRequired
}


const Apcciboard = () => (
  <>
    <PublicHeader />

    <div
      className="section-header md:mt-[40px] mt-0"
    >
      <div className='header-content px-5'>
        <div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className='text-left'
        >
          <h1 className='display-4 fw-bold mb-2 text-white'>
            APCCI Leadership
          </h1>
        </div>
        
      </div>
      <div className='overlay'></div>
    </div>
    <BoardMembersGrid title='Board of Directors' members={boardMembers} />
    <SecretariatSection
      title='APCCI Central Secretariat'
      members={secretariatMembers}
    />
    <BoardMembersGrid
      title='Former Directors'
      members={formerDirectors}
    />
    {/* <BoardMembersGrid
      title='National Advisory Council'
      members={honoraryMembers}
    /> */}
    
    <Footer />
  </>
)

export default Apcciboard
